import { IndicatorBadge, type ColumnDef } from '@talos/kyoko';
import type { ICellRendererParams, ValueGetterParams } from 'ag-grid-community';

interface GetRowTypeColumnParams<TRow> {
  id?: string;
  initialPinned?: ColumnDef<TRow>['initialPinned'];
  getRowType: (data: TRow) => string | undefined;
  enableRowGroup?: boolean;
}

export function getRowTypeColumn<TRow>({
  id,
  initialPinned,
  getRowType,
  enableRowGroup,
}: GetRowTypeColumnParams<TRow>): ColumnDef<TRow> {
  return {
    type: 'custom',
    field: 'RowType',
    enableRowGroup,
    ...(id == null ? {} : { id }),
    title: 'Type',
    ...(initialPinned === undefined ? {} : { initialPinned }),
    initialWidth: 80,
    params: {
      valueGetter: (params: ValueGetterParams<TRow>) => {
        if (params.data == null) {
          return undefined;
        }
        return getRowType(params.data);
      },
      cellRenderer: (params: ICellRendererParams<TRow, string>) => {
        if (params.value == null) {
          return null;
        }
        return <IndicatorBadge>{params.value}</IndicatorBadge>;
      },
    },
  } as ColumnDef<TRow>;
}
